import { useCallback, useState } from 'react';
import { availabilityReportService } from '@/services';

export const useDownloadAvailabilityReport = () => {
  const [isDownloading, setIsDownloading] = useState(false);
  const [downloadError, setDownloadError] = useState<string | null>(null);

  const download = useCallback(async (id: number, filename?: string) => {
    setIsDownloading(true);
    setDownloadError(null);
    try {
      const blob = await availabilityReportService.downloadReport(id);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename ?? `availability_report_${id}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      setDownloadError(err instanceof Error ? err.message : 'Failed to download report');
    } finally {
      setIsDownloading(false);
    }
  }, []);

  return { download, isDownloading, downloadError };
};
